/*@flow*/
import getTypeAtPath from './getTypeAtPath';
import getTypeInfo from './getTypeInfo';
import type { PathT, FieldT } from '../types';
import type { TypeT } from 'lib/t/types';
import EmptyArray from 'lib/EmptyArray';
import nested from 'lib/nested';

export default function getFieldInfo<V: any>(
  pathFromRoot: PathT,
  rootType: TypeT<*>,
  rootValue: any
): FieldT {
  // TODO: memo
  const fieldType = getTypeAtPath(rootType, pathFromRoot, rootValue);

  // TODO: memo
  let fieldValue = nested<V>(
    rootValue,
    pathFromRoot,
    EmptyArray.is(pathFromRoot) ? rootValue : undefined
  );

  // TODO: transform

  // TODO: memo
  const typeInfo = getTypeInfo(fieldType);

  // TODO: memo
  const fieldOptions = fieldType.meta.options || {};

  return {
    typeInfo,
    fieldValue,
    fieldType,
    fieldOptions,
  };
}
